import { ValidatorFn, FormGroup } from '@angular/forms';
import { DateTime } from 'luxon';

type TFormGroupFilters = {
  start_date: DateTime;
  end_date: DateTime;
};

export function minStartDateValidator(): ValidatorFn {
  return function validate(contract: FormGroup) {
    const { start_date, end_date } = contract.value as TFormGroupFilters;

    const startDate = start_date?.toFormat('yyyyMMdd');
    const endDate = end_date?.toFormat('yyyyMMdd');

    if (startDate > endDate) {
      return { min_start_date: 'Invalid' };
    }

    return null;
  };
}
